<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Record Refund</p>
    </header>
    <section class="modal-card-body" style="min-width: 800px;">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Paid Amount</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              {{Payment?.AmountPaidString || (Payment?.AmountPaid | currency)}}
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Refunded Amount</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <app-currency-input
                [InternalValue]="PaidAmount"
                [MaxValue]="PaidAmount"
                (ValueChanged)="UpdateValue($event)">
              </app-currency-input>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Reason</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input class="input" type="text" [(ngModel)]="Reason" maxlength="256" />
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Notes</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <textarea class="textarea" [(ngModel)]="Notes" rows="3" maxlength="1024"></textarea>
            </p>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button class="button has-background-white mr-2" (click)="close()">
        <span class="icon"><i class="fa fa-xmark"></i></span><span>Cancel</span>
      </button>
      <app-modal-save-button
        [Disabled]="RefundedAmount <= 0 || RefundedAmount == null || !Reason || !Reason.trim()"
        (OnSave)="confirm()">
      </app-modal-save-button>
    </footer>
  </div>
</div>

